import { createFileRoute } from "@tanstack/react-router";
import { SupplierImportedCatalogTab } from "../../../../features/supplier-imported-catalog/supplier-imported-catalog-tab";

export const Route = createFileRoute("/_auth/_frame/suppliers/$supplierId/imported-catalog")({
  component: SupplierImportedCatalogTab,
});
